module.exports = __webpack_public_path__ + "static/media/change.598deae7.svg";